import React, {Component} from 'react';
import Grid from '@react/react-spectrum/Grid/js/Grid';
import GridColumn from '@react/react-spectrum/Grid/js/GridColumn';
import GridRow from '@react/react-spectrum/Grid/js/GridRow';
import Heading from '@react/react-spectrum/Heading/js/Heading';
import Button from '@react/react-spectrum/Button';
import { Translate } from 'react-redux-i18n';
import { CONTACT_HELPDESK } from '../config/constants';

class RegAnotherProg extends Component{ 
    
    render(){
        return <div>
            <Grid>  
                <GridRow>
                    <GridColumn size={[12,8,6,6]} offsetSize={[0,2,3,3]}>
                        <Heading className = "heading dark padding-3" variant="pageTitle"><Translate value="uplevelRenewal.problem_header"/></Heading>
                        <GridRow  className="padding-3 font">
                            <GridColumn>
                                { 
                                   this.props.app === "renewal" ? <Translate value="uplevelRenewal.renewal_unauthorized" /> :<Translate value="uplevelRenewal.OnbrdErrorUnauthorized" />
                                }
                            </GridColumn>
                        </GridRow>
                        <GridRow className="padding-3">
                            <GridColumn>
                                <Button variant="cta" onClick={()=>{
                                    window.adobeIMS.signOut();
                                }
                                }><Translate value="uplevelRenewal.sign_in" /></Button>
                                <Button variant="primary" onClick={()=>{
                                    window.open(CONTACT_HELPDESK,"_blank");
                                }
                                }><Translate value="uplevelRenewal.Contact Helpdesk" /></Button>
                            </GridColumn>
                        </GridRow>
                    </GridColumn>
                </GridRow>
            </Grid>
            </div>
    }
}

export default RegAnotherProg;